/*@ngInject*/
const RegistrationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteRegistration = function (url) {
        if (!_.isNil(url)) {
            if (_.isNil(url.params)) {
                return this.delete(url);
            } else {
                return this.delete(url.url, {params: url.params});
            }
        } else {
            return Promise.resolve();
        }
    };
};

angular.module('umCore')
    .service('registrationRepository', RegistrationRepository);
